import type { SheetData } from '../types';

/**
 * Convert table rows to sheet format
 * Processes raw table data by filtering out internal metadata keys
 * and converting values to appropriate export types
 */
export const convertTableDataToSheet = (
  data: Array<Record<string, unknown>>
): SheetData[] => {
  return data.map((row) => {
    const out: Record<string, string | number> = {};
    Object.entries(row).forEach(([key, value]) => {
      if (key.startsWith('__')) return;
      if (typeof value === 'number') {
        out[key] = value;
      } else if (typeof value === 'string') {
        out[key] = value;
      } else if (value === null || value === undefined) {
        out[key] = '';
      } else if (typeof value === 'boolean') {
        out[key] = value ? 'true' : 'false';
      } else {
        out[key] = String(value);
      }
    });
    return out;
  });
};
